// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1b82f4ff","453":"b50ed26b"}[chunkId] + ".chunk.js";
};